/* Pampas Mood - one sticker renderer for REQ-010 (PDP mockup, editor, cart thumbnail, print).
   One model in, the same picture out. Vanilla JS, no dependencies. Exposes window.PMSticker.
   Model:
   {
     paper: { w: 105, h: 148 },            // mm; print canvas keeps this ratio (A6 default)
     heading: '',                          // template heading (optional)
     body: 'תודה\nמכל הלב',                // main text; '\n' = new line
     from: '',                             // signature line, printed at the bottom when set
     center: false,                        // free text: centre icon + body vertically
     font: { text: 'Secular One', from: 'Secular One' }, bold: { text: false, from: false },
     size: { text: 1, from: 1, heart: 1, logo: 1 },   // scale factors
     pos:  { text: [0,0], from: [0,0], heart: [0,0], logo: [0,0] },  // offsets in em
     heart: { on: true, d: 'M12 20s…' },   // built-in icon (any ICONS path)
     logo: null,                           // image URL / data URL, or null
     extras: [ { k: 'x1', type: 'text'|'icon'|'logo', text, d, src, font, bold, size, pos } ],
     fit: 1                                // auto-fit factor for the body (from the editor)
   }
*/
(function () {
  'use strict';
  var INK = '#34261C';
  var SVGNS = 'http://www.w3.org/2000/svg';

  function el(tag, style, text) {
    var e = document.createElement(tag);
    if (style) e.setAttribute('style', style);
    if (text != null) e.textContent = text;
    return e;
  }
  function v(o, k, d) { return o && o[k] != null ? o[k] : d; }
  function tr(p) { p = p || [0, 0]; return 'transform:translate(' + p[0] + 'em,' + p[1] + 'em);'; }
  function icon(d, sizeEm) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', INK); s.setAttribute('stroke-width', '1.4');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('style', 'display:block;width:100%;height:100%');
    var p = document.createElementNS(SVGNS, 'path'); p.setAttribute('d', d); s.appendChild(p);
    return s;
  }

  /* text styling per layer (Ran 20.10): italic, underline, alignment and a box (frame or soft background, no colour).
     Bold stays in m.bold. Print (toCanvas) reads the same computed styles, so preview = print. */
  var BOLD_OK = { 'Heebo': 1, 'Frank Ruhl Libre': 1, 'Amatic SC': 1 }, ITALIC_OK = {};
  function tstyle(s) {
    s = s || {}; var css = '';
    if (s.i) css += 'font-style:italic;';
    if (s.u) css += 'text-decoration:underline;text-decoration-thickness:.06em;text-underline-offset:.18em;';
    var al = s.align || 'center';
    if (al !== 'center') css += 'text-align:' + al + ';';
    if (s.box === 'frame' || s.box === 'fill') {
      css += 'width:fit-content;padding:.12em .45em;border-radius:.25em;box-sizing:border-box;align-self:' + (al === 'right' ? 'flex-start' : al === 'left' ? 'flex-end' : 'center') + ';';
      css += s.box === 'frame' ? 'border:.07em solid ' + INK + ';' : 'background:rgba(52,38,28,.10);';
    } else if (al !== 'center') css += 'align-self:stretch;';
    return css;
  }
  /* Render into `zone` (an element whose font-size sets the scale). Returns the zone.
     Every printable element carries data-pm-el = text | icon | logo, so print can find it. */
  function render(m, zone) {
    m = m || {};
    zone.innerHTML = '';
    zone.setAttribute('dir', 'rtl');
    /* m.iconBelow (Ran 21.10, the placeholder design): the icon under the text instead of above it */
    var center = !!m.center, heartOn = !!(m.heart && m.heart.on), below = !!m.iconBelow, hEl = null;
    if (getComputedStyle(zone).position === 'static') zone.style.position = 'relative';
    zone.style.cssText += ';display:flex;flex-direction:column;align-items:center;gap:.35em;text-align:center;color:' + INK + ';line-height:1.25;box-sizing:border-box;';
    var size = m.size || {}, pos = m.pos || {}, font = m.font || {}, bold = m.bold || {}, sty = m.style || {};

    if (heartOn) {
      var hs = 1.5 * v(size, 'heart', 1);
      var h = el('span', 'position:relative;display:block;flex:0 0 auto;width:' + hs + 'em;height:' + hs + 'em;' + (center ? (below ? (m.from || m.fromShown ? '' : 'margin-bottom:auto;') : 'margin-top:auto;') : '') + tr(pos.heart));
      h.dataset.pmEl = 'icon'; h.dataset.pmKey = 'heart'; h.dataset.pmD = m.heart.d; h.appendChild(icon(m.heart.d)); if (m._hide !== 'heart') { if (below) hEl = h; else zone.appendChild(h); }
    }
    if (m.heading) {
      var hd = el('span', "position:relative;font-family:'" + v(font, 'heading', 'Secular One') + "','Secular One',sans-serif;font-weight:" + (bold.heading ? 700 : 400) + ";font-size:" + (0.9 * v(size, 'heading', 1)).toFixed(3) + "em;display:block;" + tstyle(sty.heading) + tr(pos.heading), m.heading);
      hd.dataset.pmEl = 'text'; hd.dataset.pmKey = 'heading'; if (m._hide === 'heading') hd.style.visibility = 'hidden'; zone.appendChild(hd);
    }
    if ((m.body || m._editing) && !m.bodyOff) {
      var bm = center ? (below ? ('margin:auto 0 ' + (heartOn || m.from || m.fromShown ? '0' : 'auto') + ';') : ('margin:' + (heartOn ? '0' : 'auto') + ' 0 auto;')) : '';
      var b = el('span', 'position:relative;display:block;max-width:100%;white-space:pre-line;word-break:break-word;' + bm +
        "font-family:'" + v(font, 'text', 'Secular One') + "','Secular One',sans-serif;font-weight:" + (bold.text ? 700 : 400) +
        ';font-size:' + (v(m, 'fit', 1) * v(size, 'text', 1)).toFixed(3) + 'em;' + (m.body ? '' : 'color:#A8998A;') + tstyle(sty.text) + tr(pos.text), m.body || 'הטקסט שלכם יופיע כאן');
      b.dataset.pmEl = 'text'; b.dataset.pmKey = 'text'; if (m._hide === 'text') b.style.visibility = 'hidden'; zone.appendChild(b);
    }
    if (hEl) zone.appendChild(hEl);
    if (m.from || m.fromShown) {
      var f = el('span', 'position:relative;display:block;margin-top:' + (center ? '0' : 'auto') + ';' + (center && below ? 'margin-bottom:auto;' : '') +
        "font-family:'" + v(font, 'from', 'Secular One') + "','Secular One',sans-serif;font-weight:" + (bold.from ? 700 : 400) +
        ';font-size:' + (0.75 * v(size, 'from', 1)).toFixed(3) + 'em;' + (m.from ? '' : 'color:#A8998A;') + tstyle(sty.from) + tr(pos.from), m.from || 'מאת…');
      f.dataset.pmEl = 'text'; f.dataset.pmKey = 'from'; if (m._hide === 'from') f.style.visibility = 'hidden'; zone.appendChild(f);
    }
    /* round sticker (Ran 21.10): the logo in its own place sits at 8.5% from the bottom (was 2%), so its default box (4.5em wide) keeps
       its corners inside the printable circle; the legacy 3x4 label keeps 2%. The text stack leaves the logo's height free at the bottom
       (a hidden copy of the logo in the flow, reaching down to the logo's bottom edge), so the default design never overlaps it. */
    var legacy = m.shape === 'label34', lp0 = pos.logo || [0, 0];
    if (m.logo && !legacy && !lp0[0] && !lp0[1]) {
      var sp = el('span', 'display:block;flex:0 0 auto;visibility:hidden;pointer-events:none;width:' + (4.5 * v(size, 'logo', 1)) + 'em;margin-bottom:' + (-(0.14 - 0.085) * 13.75).toFixed(3) + 'em;' + (center ? '' : 'margin-top:auto;'));
      sp.setAttribute('aria-hidden', 'true'); var si = el('img'); si.src = m.logo; si.alt = ''; si.setAttribute('style', 'display:block;width:100%'); sp.appendChild(si); zone.appendChild(sp);
    }
    if (m.logo) {
      var lp = pos.logo || [0, 0];
      var lo = el('span', 'position:absolute;bottom:' + (legacy ? '2%' : '8.5%') + ';left:50%;width:' + (4.5 * v(size, 'logo', 1)) + 'em;transform:translate(calc(-50% + ' + lp[0] + 'em),' + lp[1] + 'em);');
      var li = el('img'); li.src = m.logo; li.alt = ''; li.setAttribute('style', 'display:block;width:100%;filter:grayscale(1) contrast(1.6);mix-blend-mode:multiply');
      lo.dataset.pmEl = 'logo'; lo.dataset.pmKey = 'logo'; lo.appendChild(li); zone.appendChild(lo);
    }
    (m.extras || []).forEach(function (x) {
      var p = x.pos || [0, 0], L = x.size || 1;
      var base = 'position:absolute;left:50%;top:50%;transform:translate(calc(-50% + ' + p[0] + 'em),calc(-50% + ' + p[1] + 'em));';
      var e;
      if (x.type === 'text') {
        if (!x.text && !m._editing) return;
        /* width:max-content so an absolutely placed text can use the label's full width (at left:50% the browser
           allowed only half of it, so some extra texts wrapped early; Ran 20.10) */
        e = el('span', base + "display:block;width:max-content;max-width:100%;white-space:pre-line;font-family:'" + (x.font || 'Secular One') + "','Secular One',sans-serif;font-weight:" + (x.bold ? 700 : 400) + ';font-size:' + (0.9 * L).toFixed(3) + 'em;line-height:1.2;' + tstyle(x.style) + (x.text ? '' : ';color:#A8998A'), x.text || 'טקסט חדש');
        e.dataset.pmEl = 'text';
      } else if (x.type === 'icon') {
        e = el('span', base + 'display:block;width:' + (1.5 * L) + 'em;height:' + (1.5 * L) + 'em');
        e.dataset.pmEl = 'icon'; e.dataset.pmD = x.d; e.appendChild(icon(x.d));
      } else if (x.type === 'logo' && x.src) {
        e = el('span', base + 'display:block;width:' + (4.5 * L) + 'em');
        var im = el('img'); im.src = x.src; im.alt = ''; im.setAttribute('style', 'display:block;width:100%;filter:grayscale(1) contrast(1.6);mix-blend-mode:multiply');
        e.dataset.pmEl = 'logo'; e.appendChild(im);
      }
      if (e) { e.dataset.pmKey = x.k; if (m._hide === x.k) e.style.visibility = 'hidden'; zone.appendChild(e); }
    });
    return zone;
  }

  function loadImage(src) {
    return new Promise(function (ok, no) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = no; i.src = src; });
  }
  function px(n) { return parseFloat(n) || 0; }

  /* Print: render the model off-screen at the paper ratio, then copy every element onto a canvas
     with ONE scale factor (the old code used different x and y factors). */
  /* the lines exactly as the browser laid them out (manual line breaks and automatic wrapping), so print = preview */
  function visualLines(e) {
    var out = [], cur = '', lastTop = null, rg = document.createRange();
    var w = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      for (var i = 0; i < t.length; i++) {
        var ch = t[i];
        if (ch === '\n') { out.push(cur); cur = ''; lastTop = null; continue; }
        rg.setStart(n, i); rg.setEnd(n, i + 1);
        var r = rg.getClientRects()[0];
        if (r && r.width > 0) {
          if (lastTop !== null && r.top > lastTop + r.height * 0.5) { out.push(cur); cur = ''; }
          lastTop = r.top;
        }
        cur += ch;
      }
    }
    out.push(cur);
    return out.map(function (l) { return l.replace(/^\s+|\s+$/g, ''); });
  }
  /* client 22.10 (the print file did not match the design: on a phone the text was drawn into the heart): the baseline of each
     visual line as the browser itself laid it out. A zero-size inline-block at the line's first character sits on the baseline;
     canvas metrics ("middle" of the em box) differ per browser and font, the page layout does not. null for an empty line. */
  function lineBaselines(e) {
    var tops = [], startOfLine = true, lastTop = null, first = null, rg = document.createRange();
    var w = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      for (var i = 0; i < t.length; i++) {
        var ch = t[i];
        if (ch === '\n') { if (startOfLine) tops.push(null); startOfLine = true; lastTop = null; continue; }
        rg.setStart(n, i); rg.setEnd(n, i + 1);
        var r = rg.getClientRects()[0];
        if (r && r.width > 0) {
          if (lastTop !== null && r.top > lastTop + r.height * 0.5) startOfLine = true;
          if (startOfLine) { tops.push(r.top); startOfLine = false; if (!first) first = { n: n, i: i, top: r.top }; }
          lastTop = r.top;
        }
      }
    }
    if (startOfLine) tops.push(null);
    if (!first) return tops;
    /* one marker before the element's first character (no line break can come before it): its bottom is that line's baseline,
       so (baseline - top of the character's box) is the font's own ascent as laid out; every line of this element shares it */
    var m = document.createElement('span'); m.style.cssText = 'display:inline-block;width:0;height:0;vertical-align:baseline;';
    var r2 = document.createRange(); r2.setStart(first.n, first.i); r2.collapse(true); r2.insertNode(m);
    var off = m.getBoundingClientRect().bottom - first.top;
    m.parentNode.removeChild(m); e.normalize();
    return tops.map(function (tp) { return tp === null ? null : tp + off; });
  }
  /* the printable circle (Ran 21.10): the shift [dx, dy] that brings a drawn box r {left, top, width, height} inside the circle
     of radius R around (cx, cy) with all four corners, by the shortest move (a box centred on an axis stays on it); [0, 0]
     when it is inside already (corners <= R, the same test as the editor's fitIn). A moved box lands EDGE px inside R, against
     rounding of the stored em position. A box too large for that is centred (the caller shrinks it). */
  var SAFE = 0.9, EDGE = 0.5;
  function inCircle(r, cx, cy, R) {
    var hw = r.width / 2, hh = r.height / 2, x = r.left + hw - cx, y = r.top + hh - cy, a = Math.abs(x), b = Math.abs(y);
    if (Math.hypot(a + hw, b + hh) <= R) return [0, 0];
    R -= EDGE;
    if (Math.hypot(hw, hh) >= R) return [-x, -y];
    var ux = a + hw, uy = b + hh, L = Math.hypot(ux, uy), na = ux * R / L - hw, nb = uy * R / L - hh;
    if (na < 0) { na = 0; nb = Math.sqrt(R * R - hw * hw) - hh; } else if (nb < 0) { nb = 0; na = Math.sqrt(R * R - hh * hh) - hw; }
    return [(x < 0 ? -na : na) - x, (y < 0 ? -nb : nb) - y];
  }
  function toCanvas(m, opts) {
    opts = opts || {};
    /* Ran 21.10: the placeholder design is shown only; it is never printed */
    if (m && m.placeholder) return Promise.reject(new Error('placeholder design'));
    /* round 5 cm add-on sticker (client 19.10: usually 5 cm round, clear): drawn square at true size (590px = 50mm @300dpi)
       and centred on the A6 page the print pipeline expects */
    /* white 3×4 cm label (the candle's sticker until Ran 20.10, now round 5 cm): kept for cart lines saved before; 354×472px = 30×40mm @300dpi, centred on A6 */
    if (m && m.shape === 'label34' && !opts._inner) {
      return toCanvas(m, { width: 354, _inner: true, paper: { w: 30, h: 40 } }).then(function (sq) {
        var c = document.createElement('canvas'); c.width = 1240; c.height = 1748; var x = c.getContext('2d');
        x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, c.width, c.height); x.drawImage(sq, (c.width - sq.width) / 2, (c.height - sq.height) / 2); return c;
      });
    }
    if (m && m.shape === 'round' && !opts._inner) {
      return toCanvas(m, { width: 590, _inner: true, paper: { w: 50, h: 50 } }).then(function (sq) {
        var c = document.createElement('canvas'); c.width = 1240; c.height = 1748; var x = c.getContext('2d');
        x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, c.width, c.height); x.drawImage(sq, (c.width - sq.width) / 2, (c.height - sq.height) / 2); return c;
      });
    }
    var W = opts.width || 1240;
    var paper = opts.paper || (m && m.paper) || { w: 105, h: 148 };
    var round = m && m.shape === 'round';
    var H = Math.round(W * paper.h / paper.w);
    var stageW = 360, stageH = Math.round(stageW * paper.h / paper.w);
    var k = W / stageW;
    var host = el('div', 'position:fixed;left:-10000px;top:0;width:' + stageW + 'px;height:' + stageH + 'px;background:#fff;');
    var zone = el('div', 'position:absolute;inset:0;padding:' + (round ? '14%' : '2.5% 2%') + ';font-size:' + (stageH * (round ? 0.0727 : 0.064)) + 'px;');
    host.appendChild(zone); document.body.appendChild(host);
    render(m, zone);
    var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    /* images (logo and the stack's room for it) are measured only once they are decoded */
    ready = ready.then(function () { return Promise.all([].slice.call(zone.querySelectorAll('img')).map(function (i) { return i.complete && i.naturalWidth ? 0 : (i.decode ? i.decode().catch(function () {}) : 0); })); });
    return ready.then(function () {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var x = c.getContext('2d');
      x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, W, H);
      /* round sticker (Ran 21.10): nothing is ever drawn outside the sticker's circle */
      if (round) { x.beginPath(); x.arc(W / 2, H / 2, Math.min(W, H) / 2, 0, Math.PI * 2); x.clip(); }
      x.direction = 'rtl'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillStyle = INK; x.strokeStyle = INK;
      var s = host.getBoundingClientRect();
      var jobs = [];
      zone.querySelectorAll('[data-pm-el]').forEach(function (e) {
        var r = e.getBoundingClientRect();
        /* a layer the customer dragged (non-zero pos) and saved outside the printable circle (old carts) is moved inside by the
           editor's rule: corners within SAFE of the radius. Layers in their own place (the text stack, the logo) are not moved. */
        var pk = e.dataset.pmKey, pp = (m.pos || {})[pk] || ((m.extras || []).filter(function (q) { return q.k === pk; })[0] || {}).pos || [0, 0];
        var sh = round && (pp[0] || pp[1]) ? inCircle({ left: r.left - s.left, top: r.top - s.top, width: r.width, height: r.height }, stageW / 2, stageH / 2, Math.min(stageW, stageH) / 2 * SAFE) : [0, 0];
        r = { left: r.left + sh[0], top: r.top + sh[1], width: r.width, height: r.height };
        var cx = (r.left - s.left + r.width / 2) * k, cy = (r.top - s.top + r.height / 2) * k;
        var type = e.dataset.pmEl;
        if (type === 'text') {
          var cs = getComputedStyle(e), size = px(cs.fontSize) * k;
          var fam = (cs.fontFamily || '').split(',')[0].replace(/["']/g, '').trim() || 'Secular One';
          var bases = lineBaselines(e), lines = visualLines(e), lh = size * (px(cs.lineHeight) / px(cs.fontSize) || 1.25);
          /* the baselines in canvas pixels (moved with the box when it was brought inside the circle); a missing one (an empty line) follows the line above */
          var useBase = bases.length === lines.length && bases.some(function (b) { return b !== null; });
          if (useBase) { var pb = null; bases = bases.map(function (b, i) { if (b === null) return pb === null ? null : (pb += lh / k); pb = b; return b; }); if (bases[0] === null) { var fb = bases.filter(function (b) { return b !== null; })[0], fi = bases.indexOf(fb); for (var q = fi - 1; q >= 0; q--) bases[q] = bases[q + 1] - lh / k; } bases = bases.map(function (b) { return (b + sh[1] - s.top) * k; }); }
          var bx = (r.left - s.left) * k, by = (r.top - s.top) * k, bw2 = r.width * k, bh2 = r.height * k;
          var padL = px(cs.paddingLeft) * k, padR = px(cs.paddingRight) * k, bord = px(cs.borderTopWidth) * k;
          var al = cs.textAlign, ital = cs.fontStyle === 'italic', und = /underline/.test(cs.textDecorationLine || cs.textDecoration || '');
          var fillBg = cs.backgroundColor && !/rgba\(0, 0, 0, 0\)|transparent/.test(cs.backgroundColor) ? cs.backgroundColor : null, rad = px(cs.borderTopLeftRadius) * k;
          jobs.push(function () {
            if (fillBg || bord) {
              x.save(); x.beginPath(); if (x.roundRect) x.roundRect(bx + bord / 2, by + bord / 2, bw2 - bord, bh2 - bord, rad); else x.rect(bx + bord / 2, by + bord / 2, bw2 - bord, bh2 - bord);
              if (fillBg) { x.fillStyle = fillBg; x.fill(); } if (bord) { x.lineWidth = bord; x.strokeStyle = INK; x.stroke(); } x.restore();
            }
            x.font = (ital ? 'italic ' : '') + (cs.fontWeight || '400') + ' ' + size + 'px "' + fam + '",Arial,sans-serif';
            x.fillStyle = INK;
            var ax = cx, ta = 'center';
            if (al === 'right' || al === 'start') { ax = bx + bw2 - bord - padR; ta = 'right'; }
            else if (al === 'left' || al === 'end') { ax = bx + bord + padL; ta = 'left'; }
            x.textAlign = ta;
            if (useBase) x.textBaseline = 'alphabetic';
            lines.forEach(function (line, i) {
              var ly = useBase ? bases[i] : cy - (lines.length * lh) / 2 + lh / 2 + i * lh;
              x.fillText(line, ax, ly);
              if (und && line) { var lw = x.measureText(line).width, x0 = ta === 'center' ? ax - lw / 2 : ta === 'right' ? ax - lw : ax; x.fillRect(x0, useBase ? ly + size * 0.12 : ly + size * 0.42, lw, Math.max(1, size * 0.06)); }
            });
            x.textAlign = 'center'; x.textBaseline = 'middle';
          });
        } else if (type === 'icon') {
          var w = r.width * k, d = e.dataset.pmD;
          jobs.push(function () {
            x.save(); x.translate(cx - w / 2, cy - w / 2); x.scale(w / 24, w / 24);
            x.lineWidth = 1.4; x.lineCap = 'round'; x.lineJoin = 'round'; x.stroke(new Path2D(d)); x.restore();
          });
        } else if (type === 'logo') {
          var img = e.querySelector('img'), bw = r.width * k, bh = r.height * k;
          jobs.push(function () {
            return loadImage(img.src).then(function (im) { x.drawImage(im, cx - bw / 2, cy - bh / 2, bw, bh); }).catch(function () {});
          });
        }
      });
      return jobs.reduce(function (p, j) { return p.then(j); }, Promise.resolve()).then(function () { host.remove(); return c; });
    });
  }

  /* Minimal one-page PDF around a JPEG of the canvas (same format the live theme sends today). */
  function toPDF(c, paper) {
    paper = paper || { w: 105, h: 148 };
    var pw = (paper.w / 25.4 * 72).toFixed(2), ph = (paper.h / 25.4 * 72).toFixed(2);
    var bin = atob(c.toDataURL('image/jpeg', 0.96).split(',')[1]);
    var jpg = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) jpg[i] = bin.charCodeAt(i);
    var enc = new TextEncoder(), parts = [], off = [0], len = 0;
    function txt(s) { var b = enc.encode(s); parts.push(b); len += b.length; }
    function bytes(b) { parts.push(b); len += b.length; }
    function obj(n) { off[n] = len; txt(n + ' 0 obj\n'); }
    txt('%PDF-1.4\n%PAMPAS\n');
    obj(1); txt('<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
    obj(2); txt('<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n');
    obj(3); txt('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + pw + ' ' + ph + '] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>\nendobj\n');
    obj(4); txt('<< /Type /XObject /Subtype /Image /Width ' + c.width + ' /Height ' + c.height + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpg.length + ' >>\nstream\n'); bytes(jpg); txt('\nendstream\nendobj\n');
    var content = enc.encode('q\n' + pw + ' 0 0 ' + ph + ' 0 0 cm\n/Im0 Do\nQ\n');
    obj(5); txt('<< /Length ' + content.length + ' >>\nstream\n'); bytes(content); txt('endstream\nendobj\n');
    var xr = len; txt('xref\n0 6\n0000000000 65535 f \n');
    for (var n = 1; n <= 5; n++) txt(String(off[n]).padStart(10, '0') + ' 00000 n \n');
    txt('trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xr + '\n%%EOF');
    return new Blob(parts, { type: 'application/pdf' });
  }

  /* text scale for the label (Ran 20.10: long ready-made wordings printed tiny). The label holds about 10.4em across and
     11.6em of lines (heart, heading and "מאת" take the rest); the largest scale whose wrapped lines fit wins, so a long text
     wraps into fewer, wider lines instead of shrinking twice. The print page (A6) has slightly more room, so it fits too. */
  /* o.round (Ran 20.10, the candle sticker is a 5 cm circle): the circle's text area is about 9.6em square (padding 14% of
     13.75em) and its corners are cut off, so lines are counted narrower and the stack must stay lower than on the label */
  function fit(body, heading, from, o) {
    o = o || {}; var wide = (o.bold ? 1.08 : 1) * (o.box ? 1.12 : 1), boxH = o.box ? 0.5 : 0;
    var L = String(body || '').split('\n').map(function (l) { return String(l).replace(/[\u0591-\u05C7]/g, '').length; });
    var extra = 1.9 + (heading ? 1.15 : 0) + (from ? 0.95 : 0);
    var across = o.round ? (o.box ? 7.6 : 8.4) : (o.box ? 9.2 : 10.1), high = o.round ? 9.2 : 13.9;
    for (var f = 1.4; f > 0.3; f -= 0.02) {
      var cpl = Math.max(5, Math.floor(across / (0.52 * f * wide))), n = 0;
      L.forEach(function (c) { n += Math.max(1, Math.ceil(c / cpl)); });
      if (n * 1.25 * f + extra + boxH * f <= high) return Math.round(f * 100) / 100;
    }
    return 0.3;
  }
  /* every text on a design, in reading order (heading, greeting, extra texts, from); '' when it has none (Ran 20.10: the greeting can be deleted) */
  function textOf(m) { m = m || {}; return [m.heading, m.bodyOff ? '' : m.body].concat((m.extras || []).filter(function (x) { return x.type === 'text'; }).map(function (x) { return x.text; })).concat([m.from]).map(function (x) { return String(x || '').trim(); }).filter(Boolean).join('\n'); }
  var NOTEXT = 'ללא טקסט';
  /* Ran 21.10 (iPhone): the design shown on first entry, before the customer picks a ready design or writes a text: the candle
     photo's own placeholder ("[הכנס ברכה בהתאמה אישית]" in the editor's handwriting font "כתב יד", the heart under it, centred).
     Display only: m.placeholder makes toCanvas refuse it, and the pages never pass it to the cart. o: { from, icon: path | null } */
  var PH_TEXT = '[הכנס ברכה\nבהתאמה אישית]';
  var PH_HEART = 'M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z';
  function placeholder(o) {
    o = o || {}; var d = o.icon === undefined ? PH_HEART : o.icon, f = String(o.from || '');
    return {
      shape: 'round', size_cm: 5, tpl: '', heading: '', body: PH_TEXT, from: f, center: true, placeholder: true, iconBelow: true,
      font: { text: 'Gveret Levin', from: 'Secular One' }, size: { text: 1, from: 1, heart: 1 }, bold: { text: false, from: false }, style: { text: {}, from: {} },
      heart: { on: !!d, type: 'heart', d: d || PH_HEART }, fit: fit(PH_TEXT, false, !!f, { round: true })
    };
  }
  window.PMSticker = { textOf: textOf, NOTEXT: NOTEXT, placeholder: placeholder, PH_TEXT: PH_TEXT, render: render, toCanvas: toCanvas, toPDF: toPDF, fit: fit, inCircle: inCircle, SAFE: SAFE, EDGE: EDGE, BOLD_OK: BOLD_OK, ITALIC_OK: ITALIC_OK, version: '0.5.0' };
})();
